import React, { Component, Fragment } from 'react';
import { Filter, Main } from 'Containers/';
import { TitledCard } from 'Components/';
import { connect } from 'react-redux';

import moment from 'moment';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { withRouter } from 'react-router';
import {
  setSelectedSites,
  getReport,
  clearReport,
} from './state/report/actions';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { ReceiptsAndCollectionsReportForm } from './components/ReceiptsAndCollectionsReportForm';
import { ReceiptsAndCollectionsReportFieldEnum as Fields } from 'Common/FieldEnum';
import SelectSitesTable from 'Common/SelectSitesTable';
import { toastType, createToast } from 'Common/ToastHelper';
import _ from 'lodash';
class ReceiptsAndCollectionsContainer extends Component {
  componentDidUpdate(prevProps, prevState) {
    const { report, error } = this.props;

    if (error || _.isUndefined(error)) {
      createToast(toastType.error, 'Error', 'Error retrieving report!', true);
    } else {
      if (prevProps.report !== report && report) {
        createToast(
          toastType.success,
          'Success',
          'Report job has been enqueued!'
        );
      }
    }
    this.props.clearReport();
  }

  getMainProps = () => {
    const { loading } = this.props;

    return {
      toolbox: {
        formName: 'ReceiptsAndCollectionsReportForm',
        saveButtonProps: {
          content: 'View',
          loading: loading,
        },
        shown: true,
      },
    };
  };

  onSiteChange = (sites) => {
    this.props.setSelectedSites(sites);
  };

  handleSubmit = (formValues) => {
    const data = { ...formValues, SelectedSites: this.props.selectedSites };

    if (data.SelectedSites && data.SelectedSites.length === 0) {
      createToast(
        toastType.error,
        'Error',
        'Please select one or more sites to continue!',
        true
      );
    } else {
      this.props.getReport(data);
    }
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? (
          <LoadingPage
            message={
              this.props.loading && this.props.loadingReport
                ? 'Loading Report'
                : 'Loading'
            }
          />
        ) : undefined}
        <Filter title={'Receipts & Collections'} />
        <Main {...this.getMainProps()}>
          <TitledCard>
            <ReceiptsAndCollectionsReportForm
              onSubmit={this.handleSubmit}
              initialValues={{
                [Fields.FeedingType]: 0,
                [Fields.FromDate]: defaultDateFormat(moment()),
                [Fields.ToDate]: defaultDateFormat(moment()),
              }}
            />
            <SelectSitesTable onChange={this.onSiteChange} />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { report } = state.ReceiptsAndCollectionsReportState;
  return {
    report: report.report,
    loading: report.loading,
    loadingReport: report.loadingReport,
    selectedSites: report.selectedSites,
    error: report.error,
  };
};

export const ReceiptsAndCollections = withRouter(
  connect(mapStateToProps, { setSelectedSites, getReport, clearReport })(
    ReceiptsAndCollectionsContainer
  )
);



// WEBPACK FOOTER //
// ./src/pages/receiptsandcollections/ReceiptsAndCollections.js